/**
 * i18n setup — English (default), Slovak, German.
 *
 * Detection order: localStorage → browser language → fallback (en).
 * The user's choice is persisted in localStorage under `rentnova:lang`.
 *
 * Import this file once from main.tsx *before* rendering <App />.
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import sk from './locales/sk.json';
import de from './locales/de.json';

export const SUPPORTED_LANGUAGES = [
    { code: 'en', label: 'English',  flag: '🇬🇧' },
    { code: 'sk', label: 'Slovenčina', flag: '🇸🇰' },
    { code: 'de', label: 'Deutsch',  flag: '🇩🇪' },
] as const;

export type LanguageCode = (typeof SUPPORTED_LANGUAGES)[number]['code'];

void i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            sk: { translation: sk },
            de: { translation: de },
        },
        fallbackLng: 'en',
        supportedLngs: ['en', 'sk', 'de'],
        load: 'languageOnly',            // "en-US" → "en"
        interpolation: { escapeValue: false },
        detection: {
            order: ['localStorage', 'navigator', 'htmlTag'],
            lookupLocalStorage: 'rentnova:lang',
            caches: ['localStorage'],
        },
        returnNull: false,
    });

export default i18n;
